import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardConsultaComponent } from './card-consulta.component';
import { PerfilComponent } from './perfil/perfil.component';
import { ExpandableComponent } from './expandable/expandable.component';
import { GravacaoComponent } from './gravacao/gravacao.component';
import { ExamesPrescricoesComponent } from './exames-prescricoes/exames-prescricoes.component';
import { AnexarPrescricaoDialogComponent } from "./exames-prescricoes/anexar-prescricao/anexar-prescricao-dialog.component";
import { AnexarExameDialogComponent } from "./exames-prescricoes/anexar-exame/anexar-exame-dialog.component";
import { SolicitarExameDialogComponent } from "./exames-prescricoes/solicitar-exame/solicitar-exame-dialog.component";
import { FormsModule, ReactiveFormsModule } from '@node_modules/@angular/forms';
import { ExamePrescricaoComponent } from "./exames-prescricoes/exame-prescricao/exame-prescricao.component";
import { AnexosConsultaComponent } from './exames-prescricoes/anexos-consulta/anexos-consulta.component';

@NgModule({
    declarations: [
        CardConsultaComponent,
        PerfilComponent,
        ExpandableComponent,
        GravacaoComponent,
        ExamesPrescricoesComponent,
        AnexarPrescricaoDialogComponent,
        AnexarExameDialogComponent,
        SolicitarExameDialogComponent,
        ExamePrescricaoComponent,
        AnexosConsultaComponent
    ],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    exports: [CardConsultaComponent]
})
export class CardConsultaModule { }
